/**
 * ProductImage — serves WebP with PNG fallback.
 * Lazy loads everything except the first visible image (eager on LCP).
 *
 * Uses the /images/optimised/ folder generated by the build script.
 * Derives WebP path automatically from the .png path in products.js.
 */
export default function ProductImage({
  src,          // e.g. "/images/top-arm.png"
  alt,
  className = '',
  style = {},
  eager = false,  // set true for above-the-fold / LCP image
  sizes = '(max-width: 640px) 100vw, 800px',
}) {
  // Derive paths
  const filename = src.split('/').pop().replace('.png', '');
  const webpFull = `/images/optimised/${filename}.webp`;
  const webpSm   = `/images/optimised/${filename}-sm.webp`;
  const pngFull  = `/images/optimised/${filename}.png`;

  return (
    <picture>
      {/* Responsive WebP — small screens get the 400px version */}
      <source
        type="image/webp"
        srcSet={`${webpSm} 400w, ${webpFull} 800w`}
        sizes={sizes}
      />
      {/* PNG fallback */}
      <source
        type="image/png"
        srcSet={pngFull}
      />
      <img
        src={pngFull}
        alt={alt}
        className={className}
        style={style}
        loading={eager ? 'eager' : 'lazy'}
        decoding={eager ? 'sync' : 'async'}
        width={800}
        height={800}
      />
    </picture>
  );
}
